<template>
	<div class="kangfu">
		<div class="kangfu_header">
			<div class="kangfu_header_item ">
				<div class="icon cuzhongkangfu"></div>
				<div class="title">卒中康复</div>
			</div>
		</div>
		<div class="kangfu_content">
			<div class="kangfu_content_left">
				<leftButton :list="list" v-model="actionPart" />
			</div>
			<div class="kangfu_content_right">
				<rightVideo v-for="(item,index) in videoList" :key="index" :item="item" />
				<div style="clear:both"></div>
			</div>
		</div>
	</div>
</template>
<script>
import leftButton from './components/kangfu-button.vue'
import rightVideo from './components/kangfu-video.vue'
export default {
    name: 'kangfu',
    components: { leftButton, rightVideo },
    data () {
        return {
            list: ['全部', '上肢', '下肢', '肩/肘', '手/腕', '髋/膝/踝', '平衡/转移', '颈部/胸廓/呼吸'],
            videoList: [],
            videoType: '卒中康复',
            actionPart: '全部',
        }
    },
    watch: {
        actionPart: function (val) {
            if (val) {
                this.getDataList()
            }
        }
    },
    created () {
        this.getDataList()
    },
    methods: {
        getDataList () {
            this.$api.information.getActionlibrary({
                page: 1,
                limit: 999,
                videoType: this.videoType,
                actionPart: this.actionPart === '全部' ? '' : this.actionPart
            }).then(({ code, data }) => {
                if (!code) {
                    this.videoList = data.list
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
.kangfu {
	&_header {
		display: flex;
		padding: 36px 34px;
		&_item {
			display: flex;
			border-radius: 30px;
			background-color: #dff7f7;
			align-items: center;
			justify-content: center;
			height: 145px;
			flex: 1;
			.icon {
				width: 102px;
				height: 90px;
				background-size: 100% 100%;
			}
			.title {
				font-size: 32px;
				color: #302722;
				margin-left: 26px;
			}
		}
	}
	.cuzhongkangfu {
		background-image: url('../../assets/icon/zuzhongkangfu.png');
	}
	&_content {
		display: flex;
		&_left {
			min-height: calc(100vh - 2.5rem - 220px);
			width: 180px;
		}
		&_right {
			min-height: calc(100vh - 2.5rem - 220px);
			background-color: #f5f6f7;
			flex: 1;
			padding: 30px 0 0 20px;
		}
	}
}
</style>